import React from 'react'
import {AiOutlineClose} from 'react-icons/ai'
import { useSelector,useDispatch } from 'react-redux'
import { closeRegister} from '../redux/UserSlide'

const RegisterModal = () => {
    const dispatch=useDispatch() 
    const open=useSelector(state=>state.user.openRegister)

   

  return (
    <div className={`w-full h-[100vh] bg-[#000080cb] flex justify-start flex-col items-center fixed top-0 left-0 z-[50] px-3 py-10 ${open ? 'block z-50':'hidden'}`}>
        <AiOutlineClose className='text-white text-2xl md:text-3xl absolute right-2 md:right-[100px] top-[35px] cursor-pointer' onClick={()=>{dispatch(closeRegister())}}/>
        <div className='w-[90%] md:w-[75%] bg-white mt-10 relative  px-3 md:py-3 overflow-y-auto h-[60vh]'>        
            <div className='w-full flex justify-center items-center pt-4'>
                <h4 className='text-xl font-semibold md:text-2xl'>New User Registration</h4>
            </div>
            <div className='w-full grid grid-cols-1 md:grid-cols-3 px-3 py-1 border-2 border-slate-100 md:mt-2 text-sm'>
                <div className='col-span-1'>
                    <label htmlFor="email">Full Name</label>
                </div>
                <div className='col-span-2'>
                    <input type="text" className='w-full bg-[#000080cb] p-1 focus:bg-[#5151d6cb] text-white  focus:outline-none' />
                </div>
            </div>
            <div className='w-full grid grid-cols-1 md:grid-cols-3 px-3 py-1 border-2 border-slate-100 md:mt-2 text-sm'>
                <div className='col-span-1'>
                    <label htmlFor="email">Email</label>
                </div>
                <div className='col-span-2'>
                    <input type="text" className='w-full bg-[#000080cb] p-1 focus:bg-[#5151d6cb] text-white  focus:outline-none' />
                </div>
            </div>
            <div className='w-full grid grid-cols-1 md:grid-cols-3 px-3 py-1 border-2 border-slate-100 md:mt-2 text-sm'>
                <div className='col-span-1'>
                    <label htmlFor="password">Password</label>
                </div>
                <div className='col-span-2'>
                    <input type="password" className='w-full bg-[#000080cb]  p-1 focus:bg-[#5151d6cb] focus:outline-none text-white' />
                </div>
            </div>

            <div className='w-full grid grid-cols-1 md:grid-cols-3 px-3 py-1 border-2 border-slate-100 md:mt-2 text-sm'>
                <div className='col-span-1'>
                    <label htmlFor="email">Address</label>
                </div>
                <div className='col-span-2'>
                    <textarea cols='10' rows='4' className='w-full bg-[#000080cb] p-1 focus:bg-[#5151d6cb] text-white  focus:outline-none' ></textarea>
                </div>
            </div>

            <div className='w-full grid grid-cols-1 md:grid-cols-3 px-3 py-2 border-2 border-slate-100 mt-4 pb-10'>
                <div className='col-span-1'>
                   
                </div>
                <div className='col-span-2'>
                   <button className='w-full bg-[#000080cb] text-slate-50 p-2 mb-5 text-sm font-semibold'>Register</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default RegisterModal